import { css } from '@emotion/core';
import { variables as vars } from '@domain-group/fe-brary';
var global = vars.global;
export var sticky = topEdgeOffset => /*#__PURE__*/css("position:fixed;top:", topEdgeOffset, "px;");
export var bottom = topEdgeOffset => /*#__PURE__*/css("position:absolute;top:", topEdgeOffset, "px;");
export var sidebox = /*#__PURE__*/css("position:relative;width:320px;z-index:", global.layerFloating, ";");